export const PRE_MODERATION = '/pre_moderation/'
export const PRE_MODERATION_ALL = `${PRE_MODERATION}all` as const
export const PRE_MODERATION_CHANGE_STATUS = `${PRE_MODERATION}change-status` as const
export const PRE_MODERATION_HISTORY_CREATE = `${PRE_MODERATION}history/` as const
export const PRE_MODERATION_ASSIGNED = `${PRE_MODERATION}assigned` as const
